import { Stethoscope, SlidersHorizontal, ShieldCheck } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const cards = [
  { icon: Stethoscope, title: "Doctor-Supervised", copy: "Treatment parameters are selected according to your skin and hair characteristics." },
  { icon: SlidersHorizontal, title: "Personalised Settings", copy: "Laser treatment is adjusted according to individual skin type, hair thickness and response." },
  { icon: ShieldCheck, title: "Safety-First Approach", copy: "Your skin is assessed before treatment and monitored throughout your treatment journey." },
];

export const DoctorCare = () => (
  <section data-testid="doctor-care-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <SectionHead
        index="05"
        eyebrow="Doctor-Led Care"
        title="Your Skin Deserves Expert Care."
        copy="At Krystal Skin And Laser Clinic, your treatment is performed under doctor supervision rather than being treated as a routine salon procedure."
      />
      <div className="mt-14 grid md:grid-cols-3 gap-5">
        {cards.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.08}>
            <div
              data-testid={`doctor-card-${i + 1}`}
              className="group h-full rounded-3xl border border-champagne/60 bg-white/60 p-9 transition-[background-color,transform] duration-500 hover:-translate-y-1.5 hover:bg-white"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-teal/10 transition-colors duration-500 group-hover:bg-teal">
                <c.icon className="w-5 h-5 text-teal transition-colors duration-500 group-hover:text-champagne-light" strokeWidth={1.5} />
              </span>
              <h3 className="mt-6 font-display text-xl md:text-2xl font-medium tracking-tight text-ink">{c.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-ink/60">{c.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
